import { Parser } from '~/api';
import { GitWebhook } from '~/api/models';
import RequestService from './request';

interface CreateGitWebhookRequest {
    provider: 'github' | 'gitlab';
    directory: string;
    branch?: string | null;
    reset_hard?: boolean;
}

class GitWebhooksService {
    getAll(): Promise<ListResponse> {
        return RequestService.get('/servers/:server/git/webhooks').then(Parser.parse);
    }

    create(data: CreateGitWebhookRequest): Promise<GitWebhook> {
        return RequestService.post('/servers/:server/git/webhooks', data).then(Parser.parse);
    }

    delete(id: number): Promise<void> {
        return RequestService.delete(`/servers/:server/git/webhooks/${id}`);
    }
}

export default new GitWebhooksService();
